import React, {useEffect } from "react";
import { Col, Container, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import IconButton from '@material-ui/core/IconButton';
import ReportsForm from './components/FormFilter';

const Reports = ({ history, location }) => {
    
    useEffect(() => {
        
    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Reportes</h3>
                </Col>
            </Row>
            <ReportsForm/>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_reports', // a unique identifier for this form
})(Reports);